<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form :model="search" label-position="top" label-width="" class = "el-form–label-top">
        <el-row :gutter="16">
          <el-col :span="6">
            <el-form-item label="Product Name">
              <el-select
                v-model="search.product_id"
                filterable
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="(item) in this.productList"
                  :key="item.index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Product Manager"
              :span="6"
            >
              <el-select
                v-model="search.pm_id"
                filterable
                clearable
                style="width: 80%"
                :loading="loading1"
              >
                <el-option
                  v-for="(item) in pmList"
                  :value="item.value"
                  :key="item.label"
                  :label="item.label"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Status">
              <el-select
                v-model="search.status"
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="item in this.statusList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Developing Status">
              <el-select
                v-model="search.d_status"
                clearable
                style="width: 80%"
              >
                <el-option
                  v-for="item in this.d_statusList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>


        </el-row>
        <el-row type="flex" :gutter="16">
          <el-col :span="3">
            <el-button type="text" class="btn" @click="handleReset">
              Reset
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" class="btn" @click="getProjectList">
              Search
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always" title="Project List" style="width: 100%">
      <el-form>
        <el-table
          :data="projectList" border
          style="width: 100%"
          row-key="id"
          lazy
        >
          <el-table-column
            prop="projectId"
            label="ID#"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="productName"
            label="Product"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="planVersion"
            label="Version"
            sortable
          >
          </el-table-column>
          <el-table-column
              prop="aliasName"
              label="Alias Name"
              sortable
          >
          </el-table-column>
          <el-table-column
            label="Requirements"
          >
            <template slot-scope="scope">
              <el-select
                disabled
                multiple
                v-model="scope.row.reqs"
              >
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            prop="dueDate"
            label="Due Date"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="projectType"
            label="Project Type"
          >
          </el-table-column>
          <el-table-column
            prop="pmName"
            label="Project Manager"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="dStatus"
            label="Developing Status"
            sortable
          >
          </el-table-column>
          <el-table-column
            prop="progress"
            label="Progress"
          >
          </el-table-column>
          <el-table-column
            prop="risk"
            label="Risk"
          >
          </el-table-column>

          <el-table-column
            label="Action"
            width="180">
            <template slot-scope="scope">
              <div>
                <el-button
                  size="small"
                  type="primary"
                  @click="handleEditRouter(scope.$index, scope.row)"
                >
                  Edit
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  v-if="scope.row.status==='To Do'"
                  @click="deleteProject(scope.$index, scope.row)"
                >
                  Delete
                </el-button>
              </div>
            </template>
          </el-table-column>


        </el-table>
        <el-pagination
          :current-page.sync="search.currentPage"
          :page-sizes="[10,20,50]"
          :total="search.totalPage"
          :page-size.sync="search.pageSize"
          prev-text="Previous"
          next-text="Next"
          style="margin-top: 4px"
          show-total
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />

      </el-form>
    </el-card>


  </div>

</template>

<script>
import projectApi from "@/api/project";
import productApi from "@/api/product";
import userApi from "@/api/user";
import {PathName} from "@/constant/routeData";

export default {
  name: "projectList",
  data() {
    return {
      productList:[],
      projectList:[],
      reqs:[],
      statusList:['To Do','In Progress','Hold','Complete'],
      d_statusList:['To Do','Designing','Developing','Testing','Debug/Bug fixing','Releasing','Archive'],
      pmList:[],
      loading1: false,
      editIndex: -1,
      isEdit: -99,
      search: {
        user: '',
        product_id: '',
        status: '',
        d_status: '',
        pm_id:'',
        project_type: '',
        pageSize: 10,
        totalPage: 0,
      },
    }
  },
  methods:{
    getProjectList(){
      let para = {}
      para['offset'] = this.search.pageSize * (this.search.currentPage -1)
      para['limit'] = this.search.pageSize
      if (this.search.product_id) {
        para['product_id'] = this.search.product_id
      }
      if (this.search.pm_id) {
        para['pm_id'] = this.search.pm_id
      }
      if (this.search.status) {
        para['status'] = this.search.status
      }
      if (this.search.d_status) {
        para['d_status'] = this.search.d_status
      }
      projectApi.getProjects(para).then(
        res => {
          this.projectList = res.data.data
          this.reqs = res.data.data['reqs']
          this.search.totalPage = res.data.total
        }
      )
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.pmList.push({value: user.id, label: user['fullName']})
        }
      })
      productApi.getProducts().then(res=> {
          let products = res.data
          for (let product of products) {
            this.productList.push({value: product.id, label: product.name})
          }
        }
      )

    },
    handleReset() {
      this.search.product_id = null
      this.search.pm_id = null
    },
    handleSizeChange(val) {
      this.search.pageSize = val
      this.getProjectList()
      // 在此刷新数据
    },
    handleCurrentChange(val){
      this.search.currentPage = val
      this.getProjectList()
    },
    deleteProject(index, row){
      this.$confirm('Delete the project, continue?', 'Tips', {
        type: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then(() => {
        let para = { id: row.id }
        projectApi.delProject(para).then(resp => {
          this.$message.success({
            message: resp['msg'],
            type: "success"
          })
          this.getProjectList()
        })
      })
    },
    handleEditRouter(index,row) {
      const id = row.id
      let routeData = this.$router.resolve({name: PathName.ProjectEdit, query:{id:id}});
      window.open(routeData.href, '_blank');
    },
  },
  mounted(){
    this.getSelects()
    this.getProjectList()
  },
}



</script>

<style lang="scss" scoped>
.st-table {
  padding:10px
}
.el-form–label-top {
  text-align: left !important;
}

</style>
